[
  {
    "code": "BI-BB",
    "name": "Bubanza"
  },
  {
    "code": "BI-BJ",
    "name": "Bujumbura"
  },
  {
    "code": "BI-BR",
    "name": "Bururi"
  },
  {
    "code": "BI-CA",
    "name": "Cankuzo"
  },
  {
    "code": "BI-CI",
    "name": "Cibitoke"
  },
  {
    "code": "BI-GI",
    "name": "Gitega"
  },
  {
    "code": "BI-KR",
    "name": "Karuzi"
  },
  {
    "code": "BI-KY",
    "name": "Kayanza"
  },
  {
    "code": "BI-KI",
    "name": "Kirundo"
  },
  {
    "code": "BI-MA",
    "name": "Makamba"
  },
  {
    "code": "BI-MU",
    "name": "Muramvya"
  },
  {
    "code": "BI-MY",
    "name": "Muyinga"
  },
  {
    "code": "BI-MW",
    "name": "Mwaro"
  },
  {
    "code": "BI-NG",
    "name": "Ngozi"
  },
  {
    "code": "BI-RT",
    "name": "Rutana"
  },
  {
    "code": "BI-RY",
    "name": "Ruyigi"
  }
]